// AnimatedNumber.js
import React from 'react';
import AnimatedCounter from "./AnimatedCounter";

const AnimatedNumber = ({ number, formatter = (value) => value, hide }) => {
    const animatedValue = AnimatedCounter(number);

    if (hide) return null;
    return (
        <span>{formatter(animatedValue)}</span>
    );
};

export default AnimatedNumber;